import { Navigate } from 'react-router-dom'

/** Invitations now live in the Campaigns hub, under Incoming */
const Invitations = () => <Navigate to="/campaigns?tab=incoming" replace />

export default Invitations
